/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractTenant } from './ContractTenant';
import {
    ContractTenantFromJSON,
    ContractTenantFromJSONTyped,
    ContractTenantToJSON,
    ContractTenantToJSONTyped,
} from './ContractTenant';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * Bien couvert d'un parc GLI dans l'écran de contractualisation : identité du bien et dossier documentaire de ses locataires (mêmes ContractTenant que le mono-bien, pour réutiliser l'UI d'upload de pièces bien par bien).
 * 
 * @export
 * @interface ParcRealEstateTenantsDto
 */
export interface ParcRealEstateTenantsDto {
    /**
     * 
     * @type {string}
     * @memberof ParcRealEstateTenantsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ParcRealEstateTenantsDto
     */
    name?: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof ParcRealEstateTenantsDto
     */
    address?: AddressDto;
    /**
     * Loyer mensuel charges incluses
     * @type {number}
     * @memberof ParcRealEstateTenantsDto
     */
    rentWithCharges?: number;
    /**
     * Tous les locataires éligibles du bien ont fourni leurs pièces (et le bien a au moins un locataire)
     * @type {boolean}
     * @memberof ParcRealEstateTenantsDto
     */
    isCompleted: boolean;
    /**
     * Bien couvert par le contrat (toujours vrai en GLI, où seuls les biens couverts sont listés ; en CBNO, tous les biens du parc sont listés)
     * @type {boolean}
     * @memberof ParcRealEstateTenantsDto
     */
    covered?: boolean;
    /**
     * 
     * @type {Array<ContractTenant>}
     * @memberof ParcRealEstateTenantsDto
     */
    tenants: Array<ContractTenant>;
}

/**
 * Check if a given object implements the ParcRealEstateTenantsDto interface.
 */
export function instanceOfParcRealEstateTenantsDto(value: object): value is ParcRealEstateTenantsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('tenants' in value) || value['tenants'] === undefined) return false;
    return true;
}

export function ParcRealEstateTenantsDtoFromJSON(json: any): ParcRealEstateTenantsDto {
    return ParcRealEstateTenantsDtoFromJSONTyped(json, false);
}

export function ParcRealEstateTenantsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcRealEstateTenantsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'rentWithCharges': json['rentWithCharges'] == null ? undefined : json['rentWithCharges'],
        'isCompleted': json['isCompleted'],
        'covered': json['covered'] == null ? undefined : json['covered'],
        'tenants': ((json['tenants'] as Array<any>).map(ContractTenantFromJSON)),
    };
}

export function ParcRealEstateTenantsDtoToJSON(json: any): ParcRealEstateTenantsDto {
    return ParcRealEstateTenantsDtoToJSONTyped(json, false);
}

export function ParcRealEstateTenantsDtoToJSONTyped(value?: ParcRealEstateTenantsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': AddressDtoToJSON(value['address']),
        'rentWithCharges': value['rentWithCharges'],
        'isCompleted': value['isCompleted'],
        'covered': value['covered'],
        'tenants': ((value['tenants'] as Array<any>).map(ContractTenantToJSON)),
    };
}

